export function trackUmamiEvent(event) {
  window.umami(event);
}
